import useTouchDetection from "./useTouchDetection";
import useKeyboardDetection from "./useKeyboardDetection";
/**
 * This hook combines the touch and keyboard detection hooks and returns a
 * string of the current interaction mode of the app/user.
 *
 * @private
 */
export default function useModeDetection() {
    var touch = useTouchDetection();
    var keyboard = useKeyboardDetection();
    if (touch) {
        return "touch";
    }
    if (keyboard) {
        return "keyboard";
    }
    return "mouse";
}
//# sourceMappingURL=useModeDetection.js.map